import { GATTServiceUuid } from '@app/cnst/hardware.cnst'
import { UnixTimestamp } from '@naturalcycles/js-lib'
import { CentiCelsius, DeciVolt } from '@naturalcycles/shared'

// See BLEConfiguration_CMDWearableDevice.JSON for source
export const B1_SERVICE_UUID = {
  DEVICE_INFORMATION: GATTServiceUuid.DEVICE_INFORMATION,
  DEVICE: 'D8900100-CDB5-4F32-A5CC-FCCA4A109486',
  USER_CONFIG: 'D8910100-CDB5-4F32-A5CC-FCCA4A109486',
}

export enum B1Command {
  UNKNOWN = 0xff,
  NONE = 0x00,
  SET_TIME = 0x01,
  FACTORY_RESET = 0x02,
  FOTA = 0x03,
  START_MEASUREMENT = 0x04,
  STOP_MEASUREMENT = 0x05,
  SET_DEVICE_MODE = 0x06,
  SET_WAKEUP_THRESHOLD = 0x07,
  SET_STEP_THRESHOLD = 0x08,
  SET_MEASURE_MODE = 0x09,
  START_COLOR_CONFIG = 0x0a,
  STOP_COLOR_CONFIG = 0x0b,
  SEND_COLOR = 0x0c,
  SHIP_MODE = 0x0d,
  DEVICE_RESET = 0xf1,
  TDE_RESET = 0xf2,
  START_FT = 0xf3,
  STOP_FT = 0xf4,
}

export enum B1BatteryStatus {
  Ok = 0,
  Warning = 1,
  Limit = 2,
  Unknown = 255,
}

export interface DeviceStatus {
  batteryState: number
  batteryStateString: string
  deviceMode: number
  deviceModeString: string
  timestamp: number
  logsToRead: boolean
  state: number
  stateString: string
  batteryVoltage: number
  batteryPercent: number
  psuTsFault: number
  psuTsFaultString: string
  batteryStatus: number
  batteryStatusString: string
  measurementMode: number
  measurementModeString: string
  tempSen: number
  tempMbo: number
  heartRate: number
}

export interface ErrorStatus {
  pmicConfigError: boolean
  tempCommError: boolean
  ppgCommError: boolean
}

export interface SleepData {
  logs: SleepLogData[]
  size: number
}

export interface SleepLogData {
  hours: HourSleepLogData[]
  timestamp: UnixTimestamp
}

export interface HourSleepLogData {
  heartRate: { heartRateAvg: number }[]
  heartRateMax: number
  heartRateMin: number
  motionData: SleepMotionData[]
  temperatureMBO: CentiCelsius[]
  temperatureSEN: CentiCelsius[]
  voltage?: DeciVolt
}

export interface SleepMotionData {
  stepCount: number
  orientationCount: number
  wakeupCount: number
}
